import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a873d9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "plant-card__header" }
const _hoisted_3 = { class: "plant-card__title" }
const _hoisted_4 = { class: "plant-card__action" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "plant-card__btn-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseIcon = _resolveComponent("BaseIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "plant-card",
    "data-test": "plant-card",
    onMouseenter: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.prefetchPlantData && _ctx.prefetchPlantData(...args)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["plant-card__picture", { 'plant-card__picture--rect': _ctx.rect }])
    }, [
      _createElementVNode("img", {
        class: "plant-card__img",
        src: _ctx.plant.thumbnail,
        alt: _ctx.plant.title
      }, null, 8, _hoisted_1),
      _createVNode(_component_router_link, {
        to: { name: 'Plant', params: { id: _ctx.plant.id } },
        class: "plant-card__link",
        onClick: _ctx.logAmplitudeEvent
      }, null, 8, ["to", "onClick"])
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.plant.title), 1),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.isInMyPlants)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              disabled: _ctx.isFetch,
              type: "button",
              class: "plant-card__btn btn btn--prim",
              "data-test": "plant-card-add-btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addToMyPlants && _ctx.addToMyPlants(...args)))
            }, [
              _createVNode(_component_BaseIcon, { name: "plus" }),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('form_button_my_plants_add')), 1)
            ], 8, _hoisted_5))
          : _createCommentVNode("", true)
      ])
    ])
  ], 32))
}